module.exports = __webpack_public_path__ + "img/bm-4.2465f3f2.png";